import React, { useState, useEffect } from "react";
import "../../Styles/Member.css";
import { FaSquareWhatsapp } from "react-icons/fa6";

import Employeer from "../Membership/Employeer";
import Employee1 from "../Membership/Employee1";
import StudentForm from "../Membership/StudentForm";
import TPOForm from "../Membership/TPOForm";

import ApiService from "../../nhrc_apis/ApiService";
import { uploadSingleFile } from "../../components/utils/uploadHelper";

const { MembershipAPI } = ApiService;

const stateDistrictData = {
  "Andhra Pradesh": [
    "Anantapur",
    "Chittoor",
    "Guntur",
    "Krishna",
    "Nellore",
    "Kurnool",
  ],

  Telangana: [
    "Hyderabad",
    "Warangal",
    "Karimnagar",
    "Nizamabad",
    "Khammam",
    "Rangareddy",
  ],

  Karnataka: [
    "Bangalore",
    "Mysore",
    "Hubli",
    "Belgaum",
    "Mangalore",
  ],

  "Tamil Nadu": [
    "Chennai",
    "Coimbatore",
    "Madurai",
    "Trichy",
    "Salem",
  ],

  Gujarat: [
    "Ahmedabad",
    "Surat",
    "Vadodara",
    "Rajkot",
    "Bhavnagar",
  ],

  Maharashtra: [
    "Mumbai",
    "Pune",
    "Nagpur",
    "Nashik",
    "Aurangabad",
  ],
};

function Member() {

  const [personalData, setPersonalData] = useState({
    full_name: "",
    gender: "",
    dob: "",
    state: "",
    district: "",
    pincode: "",
    profile_photo: null,
    email: "",
    mobile: "",
    candidate_type: "",
    blood_group: "",
    whatsapp_notification: false,
  });

  const [errors, setErrors] = useState({});
  const [districts, setDistricts] = useState([]);

  const [showPersonalForm, setShowPersonalForm] =
    useState(true);

  const [showPopup, setShowPopup] =
    useState(false);

  const [currentForm, setCurrentForm] =
    useState(null);

  const [loading, setLoading] =
    useState(false);

  const [memberId, setMemberId] =
    useState(null);

  const [membershipId, setMembershipId] =
    useState(null);

  /* =========================================================
      DISTRICT CHANGE
  ========================================================= */

  useEffect(() => {

    setDistricts(
      stateDistrictData[
        personalData.state
      ] || []
    );

    setPersonalData((prev) => ({
      ...prev,
      district: "",
    }));

  }, [personalData.state]);

  /* =========================================================
      HANDLE CHANGE
  ========================================================= */

  const handleChange = (e) => {

    const {
      name,
      value,
      type,
      checked,
      files,
    } = e.target;

    if (type === "file") {

      setPersonalData((prev) => ({
        ...prev,
        profile_photo: files[0],
      }));

      setErrors((prev) => ({
        ...prev,
        profile_photo: "",
      }));

      return;
    }

    setPersonalData((prev) => ({
      ...prev,
      [name]:
        type === "checkbox"
          ? checked
          : value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  /* =========================================================
      VALIDATION
  ========================================================= */

  const validateForm = () => {

    let newErrors = {};

    const nameRegex =
      /^[A-Za-z ]{3,50}$/;

    const pinRegex =
      /^[0-9]{6}$/;

    const phoneRegex =
      /^[6-9][0-9]{9}$/;

    const emailRegex =
      /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

    if (!personalData.full_name.trim()) {

      newErrors.full_name =
        "Full name is required";

    } else if (
      !nameRegex.test(
        personalData.full_name
      )
    ) {

      newErrors.full_name =
        "Only alphabets allowed (3-50 characters)";
    }

    if (!personalData.gender) {

      newErrors.gender =
        "Please select gender";
    }

    if (!personalData.dob) {

      newErrors.dob =
        "Date of birth is required";
    }

    if (!personalData.state) {

      newErrors.state =
        "Please select state";
    }

    if (!personalData.district) {

      newErrors.district =
        "Please select district";
    }

    if (!personalData.pincode) {

      newErrors.pincode =
        "Pincode is required";

    } else if (
      !pinRegex.test(
        personalData.pincode
      )
    ) {

      newErrors.pincode =
        "Pincode must contain 6 digits";
    }

    if (!personalData.email) {

      newErrors.email =
        "Email is required";

    } else if (
      !emailRegex.test(
        personalData.email
      )
    ) {

      newErrors.email =
        "Enter valid email";
    }

    if (!personalData.mobile) {

      newErrors.mobile =
        "Mobile number is required";

    } else if (
      !phoneRegex.test(
        personalData.mobile
      )
    ) {

      newErrors.mobile =
        "Mobile must start with 6-9 and contain 10 digits";
    }

    if (!personalData.candidate_type) {

      newErrors.candidate_type =
        "Please select candidate type";
    }

    if (!personalData.blood_group) {

      newErrors.blood_group =
        "Please select blood group";
    }

    if (!personalData.profile_photo) {

      newErrors.profile_photo =
        "Please upload profile photo";
    }

    setErrors(newErrors);

    return (
      Object.keys(newErrors)
        .length === 0
    );
  };

  /* =========================================================
      BACK TO PERSONAL
  ========================================================= */

  const onBackToPersonal = () => {

    setShowPersonalForm(true);

    setShowPopup(false);

    setCurrentForm(null);
  };

  /* =========================================================
      EMPLOYEE STEP 1 SUCCESS
  ========================================================= */

  const handleEmployeeNext = (
    employeePayload
  ) => {

    console.log(
      "✅ EMPLOYEE STEP 1 DATA:",
      employeePayload
    );

    console.log(
      "CURRENT MEMBER ID:",
      memberId
    );

    console.log(
      "CURRENT MEMBERSHIP ID:",
      membershipId
    );

    const finalPayload = {

      ...employeePayload,

      member_id:
        employeePayload?.member_id ||
        memberId,

      membership_id:
        employeePayload?.membership_id ||
        membershipId,
    };

    console.log(
      "✅ FINAL EMPLOYEE DATA:",
      finalPayload
    );

    setShowPopup(false);

    setCurrentForm(
      <Employee1
  employeeData={finalPayload}
  personalData={personalData}
  memberId={finalPayload.member_id}
  membershipId={finalPayload.membership_id}
  onBack={onBackToPersonal}
/>
    );

    setShowPopup(true);
  };

  /* =========================================================
      PERSONAL SUBMIT
  ========================================================= */

  const handleSubmit = async (e) => {

    e.preventDefault();

    if (loading) return;

    if (!validateForm()) return;

    try {

      setLoading(true);

      const personalPayload = {

        full_name:
          personalData.full_name.trim(),

        gender:
          personalData.gender.toLowerCase(),

        dob:
          personalData.dob,

        state:
          personalData.state.toLowerCase(),

        district:
          personalData.district.toLowerCase(),

        pincode:
          personalData.pincode,

        email:
          personalData.email
            .trim()
            .toLowerCase(),

        mobile:
          personalData.mobile,

        blood_group:
          personalData.blood_group,

        whatsapp_notification:
          personalData.whatsapp_notification,

        candidate_type:
          personalData.candidate_type === "TPO"
            ? "representative"
            : personalData.candidate_type.toLowerCase(),
      };

      console.log(
        "🔥 PERSONAL PAYLOAD:",
        personalPayload
      );

      const res =
        await MembershipAPI.createPersonal(
          personalPayload
        );

      console.log(
        "✅ PERSONAL SUCCESS:",
        res.data
      );

      const mId =
        res?.data?.member_id;

      const memId =
        res?.data?.membership_id;

      console.log(
        "GENERATED MEMBER ID:",
        mId
      );

      console.log(
        "GENERATED MEMBERSHIP ID:",
        memId
      );

      if (!mId || !memId) {

        alert(
          "member_id or membership_id not received from backend"
        );

        return;
      }

      setMemberId(mId);

      setMembershipId(memId);

      /* =====================================================
          PROFILE PHOTO UPLOAD
      ===================================================== */

      if (personalData.profile_photo) {

        try {

          const uploadedPhotoUrl =
            await uploadSingleFile(
              personalData.profile_photo,
              memId
            );

          console.log(
            "✅ PROFILE PHOTO:",
            uploadedPhotoUrl
          );

        } catch (uploadErr) {

          console.error(
            "❌ PROFILE PHOTO ERROR:",
            uploadErr
          );
        }
      }

      setShowPersonalForm(false);

      setShowPopup(true);

      /* =====================================================
          EMPLOYEE
      ===================================================== */

      if (
        personalData.candidate_type ===
        "Employee"
      ) {

        setCurrentForm(
          <Employeer
            memberId={mId}
            membershipId={memId}
            personalData={personalData}
            onBackToPersonal={
              onBackToPersonal
            }
            onNextForm={
              handleEmployeeNext
            }
          />
        );
      }

      /* =====================================================
          STUDENT
      ===================================================== */

      if (
        personalData.candidate_type ===
        "Student"
      ) {

        setCurrentForm(
          <StudentForm
            memberId={mId}
            membershipId={memId}
            personalData={personalData}
            onBackToPersonal={
              onBackToPersonal
            }
          />
        );
      }

      /* =====================================================
          TPO
      ===================================================== */

      if (
        personalData.candidate_type ===
        "TPO"
      ) {

        setCurrentForm(
          <TPOForm
            memberId={mId}
            membershipId={memId}
            personalData={personalData}
            onBackToPersonal={
              onBackToPersonal
            }
          />
        );
      }

    } catch (error) {

      console.error(
        "❌ PERSONAL ERROR:",
        error.response?.data || error
      );

      alert(
        error?.response?.data?.detail ||
        "Something went wrong"
      );

    } finally {

      setLoading(false);
    }
  };

  return (
    <div className="memberpage-wrapper">

      {showPersonalForm && (

        <div className="memberpage-card shadow-lg rounded-4">

          <h4 className="memberpage-title">
            Personal Details
          </h4>

          <form
            className="row g-3 membershipinnercss"
            onSubmit={handleSubmit}
          >

            {/* FULL NAME */}

            <div className="col-md-6">

              <label className="form-labell">
                Full Name *
              </label>

              <input
                type="text"
                name="full_name"
                className={`form-control ${
                  errors.full_name
                    ? "input-error"
                    : ""
                }`}
                value={personalData.full_name}
                onChange={handleChange}
              />

              {errors.full_name && (
                <small className="error-text">
                  {errors.full_name}
                </small>
              )}
            </div>

            {/* GENDER */}

            <div className="col-md-6">

              <label className="form-labell">
                Gender *
              </label>

              <select
                name="gender"
                className={`form-select ${
                  errors.gender
                    ? "input-error"
                    : ""
                }`}
                value={personalData.gender}
                onChange={handleChange}
              >

                <option value="">
                  Select
                </option>

                <option>
                  Male
                </option>

                <option>
                  Female
                </option>

                <option>
                  Others
                </option>

              </select>

              {errors.gender && (
                <small className="error-text">
                  {errors.gender}
                </small>
              )}
            </div>

            {/* DOB */}

            <div className="col-md-6">

              <label className="form-labell">
                DOB *
              </label>

              <input
                type="date"
                name="dob"
                className={`form-control ${
                  errors.dob
                    ? "input-error"
                    : ""
                }`}
                value={personalData.dob}
                onChange={handleChange}
              />

              {errors.dob && (
                <small className="error-text">
                  {errors.dob}
                </small>
              )}
            </div>

            {/* STATE */}

            <div className="col-md-6">

              <label className="form-labell">
                State *
              </label>

              <select
                name="state"
                className={`form-select ${
                  errors.state
                    ? "input-error"
                    : ""
                }`}
                value={personalData.state}
                onChange={handleChange}
              >

                <option value="">
                  Select
                </option>

                {Object.keys(
                  stateDistrictData
                ).map((s) => (
                  <option key={s}>
                    {s}
                  </option>
                ))}

              </select>

              {errors.state && (
                <small className="error-text">
                  {errors.state}
                </small>
              )}
            </div>

            {/* DISTRICT */}

            <div className="col-md-6">

              <label className="form-labell">
                District *
              </label>

              <select
                name="district"
                className={`form-select ${
                  errors.district
                    ? "input-error"
                    : ""
                }`}
                value={personalData.district}
                onChange={handleChange}
              >

                <option value="">
                  Select
                </option>

                {districts.map((d) => (
                  <option key={d}>
                    {d}
                  </option>
                ))}

              </select>

              {errors.district && (
                <small className="error-text">
                  {errors.district}
                </small>
              )}
            </div>

            {/* PINCODE */}

            <div className="col-md-6">

              <label className="form-labell">
                Pincode *
              </label>

              <input
                type="text"
                name="pincode"
                className={`form-control ${
                  errors.pincode
                    ? "input-error"
                    : ""
                }`}
                value={personalData.pincode}
                onChange={handleChange}
              />

              {errors.pincode && (
                <small className="error-text">
                  {errors.pincode}
                </small>
              )}
            </div>

            {/* EMAIL */}

            <div className="col-md-6">

              <label className="form-labell">
                Email *
              </label>

              <input
                type="email"
                name="email"
                className={`form-control ${
                  errors.email
                    ? "input-error"
                    : ""
                }`}
                value={personalData.email}
                onChange={handleChange}
              />

              {errors.email && (
                <small className="error-text">
                  {errors.email}
                </small>
              )}
            </div>

            {/* MOBILE */}

            <div className="col-md-6">

              <label className="form-labell">
                Phone *
              </label>

              <input
                type="tel"
                name="mobile"
                className={`form-control ${
                  errors.mobile
                    ? "input-error"
                    : ""
                }`}
                value={personalData.mobile}
                onChange={handleChange}
              />

              {errors.mobile && (
                <small className="error-text">
                  {errors.mobile}
                </small>
              )}
            </div>

            {/* CANDIDATE TYPE */}

            <div className="col-md-6">

              <label className="form-labell">
                Candidate Type *
              </label>

              <select
                name="candidate_type"
                className={`form-select ${
                  errors.candidate_type
                    ? "input-error"
                    : ""
                }`}
                value={
                  personalData.candidate_type
                }
                onChange={handleChange}
              >

                <option value="">
                  Select
                </option>

                <option>
                  Employee
                </option>

                <option>
                  Student
                </option>

                <option>
                  TPO
                </option>

              </select>

              {errors.candidate_type && (
                <small className="error-text">
                  {
                    errors.candidate_type
                  }
                </small>
              )}
            </div>

            {/* BLOOD GROUP */}

            <div className="col-md-6">

              <label className="form-labell">
                Blood Group *
              </label>

              <select
                name="blood_group"
                className={`form-select ${
                  errors.blood_group
                    ? "input-error"
                    : ""
                }`}
                value={personalData.blood_group}
                onChange={handleChange}
              >

                <option value="">
                  Select
                </option>

                <option value="O+ve">O+</option>
                <option value="O-ve">O-</option>
                <option value="A+ve">A+</option>
                <option value="A-ve">A-</option>
                <option value="B+ve">B+</option>
                <option value="B-ve">B-</option>
                <option value="AB+ve">AB+</option>
                <option value="AB-ve">AB-</option>

              </select>

              {errors.blood_group && (
                <small className="error-text">
                  {errors.blood_group}
                </small>
              )}
            </div>

            {/* PROFILE PHOTO */}

            <div className="col-md-6">

              <label className="form-labell">
                Profile Photo *
              </label>

              <input
                type="file"
                accept="image/*"
                className={`form-control ${
                  errors.profile_photo
                    ? "input-error"
                    : ""
                }`}
                onChange={handleChange}
              />

              {errors.profile_photo && (
                <small className="error-text">
                  {
                    errors.profile_photo
                  }
                </small>
              )}
            </div>

            {/* WHATSAPP */}

            <div className="col-md-6 mt-4">

              <div className="form-check form-switch">

                <input
                  type="checkbox"
                  className="form-check-input"
                  name="whatsapp_notification"
                  checked={
                    personalData.whatsapp_notification
                  }
                  onChange={handleChange}
                />

                <label className="form-check-label">
                  Notification{" "}
                  <FaSquareWhatsapp />
                </label>

              </div>
            </div>

            {/* SUBMIT */}

            <div className="col-12 text-center mt-4">

              <button
                type="submit"
                className="btn memberpage-btn px-5"
                disabled={loading}
              >

                {loading
                  ? "Submitting..."
                  : "Submit"}

              </button>

            </div>

          </form>

        </div>
      )}

      {/* POPUP */}

      {showPopup && (

        <div className="popup-overlay">

          <div className="popup-content shadow-lg rounded-4">

            <button
              className="close-btn-member"
              onClick={onBackToPersonal}
            >
              ✕
            </button>

            {currentForm}

          </div>

        </div>
      )}
    </div>
  );
}

export default Member;